export default __webpack_public_path__ + "static/media/logo-18px-efefef.be28166f.svg";